import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  HostListener,
  ElementRef,
} from "@angular/core";

@Component({
  selector: "app-multi-select-input",
  templateUrl: "./multi-select-input.component.html",
  styleUrls: ["./multi-select-input.component.scss"],
})
export class MultiSelectInputComponent implements OnInit {
  @Input() label: string = "";
  @Input() selectOptionList: any[] = [];
  @Output() selectOptionUpdated: EventEmitter<any[]> = new EventEmitter();
  public showDropdown: boolean = false;
  public inputValue: string = "";

  private _selectedOptions: any[] = [];

  @Input()
  set selectedOptions(value: any[]) {
    this._selectedOptions = value ? [...value] : [];
    this.updateInputValue();
  }

  get selectedOptions(): any[] {
    return this._selectedOptions;
  }

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {}

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.showDropdown = false;
    }
  }

  private updateInputValue() {
    this.inputValue =
      this._selectedOptions?.length > 0
        ? `${this._selectedOptions?.length} Selected`
        : "Select options";
  }

  public onSelectAll(event: MouseEvent) {
    event.stopPropagation(); // Prevent document click handler
    this._selectedOptions = [...this.selectOptionList];
    this.updateInputValue();
    this.selectOptionUpdated.emit(this._selectedOptions);
  }

  public onClearAll(event: MouseEvent) {
    event.stopPropagation(); // Prevent document click handler
    this._selectedOptions = [];
    this.updateInputValue();
    this.selectOptionUpdated.emit(this._selectedOptions);
  }

  public onClick() {
    this.showDropdown = !this.showDropdown;
  }

  public onOptionSelect(option, event: MouseEvent) {
    event.stopPropagation(); // Prevent document click handler
    if (this._selectedOptions.includes(option)) {
      this._selectedOptions = this._selectedOptions.filter(
        (item) => item !== option,
      );
    } else {
      this._selectedOptions = [...this._selectedOptions, option];
    }
    this.updateInputValue();
    this.selectOptionUpdated.emit(this._selectedOptions);
  }
}
